<div class="grid-modal--wrapper">
    <div class="grid-modal--grid-container">
        <dx-data-grid #grid class="res-data-grid grid-modal--grid" height="100%" width="100%"
            [dataSource]="dataSource" [columns]="modalData.columns" [showBorders]="modalData.showBorders ?? true"
            [remoteOperations]="modalData.remoteOperations ?? false"
            [noDataText]="loading ? ' ' : (modalData.noDataText ?? 'No data found')"
            [showRowLines]="modalData.showRowLines ?? true"
            [allowColumnReordering]="modalData.allowColumnReordering ?? true"
            [columnAutoWidth]="modalData.columnAutoWidth ?? true" [wordWrapEnabled]="modalData.wordWrapEnabled ?? true"
            (onContentReady)="onContentReady()">

            <dxo-paging [pageSize]="modalData.pageSize ?? 10" [enabled]="modalData.pagingEnabled ?? true"></dxo-paging>
            <dxo-pager [visible]="modalData.pagerVisible ?? true" [showInfo]="true" displayMode="full"
                [allowedPageSizes]="modalData.allowedPageSizes ?? [10, 20, 40]" [showPageSizeSelector]="true"
                [showNavigationButtons]="true">
            </dxo-pager>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>

        <div *dxTemplate="let cellInfo of 'renderingFunctionTemplate'">
            {{execRenderingFunctions(cellInfo)}}
        </div>

        <div *dxTemplate="let cellInfo of 'currencyTemplate'">
            {{cellInfo.data[cellInfo.column.dataField] | formatCurrency : (cellInfo.data[modalData.currencyField ?? 'currencyCod'] || 'USD')}}
        </div>

        <div *dxTemplate="let cellInfo of 'dateTemplate'">
            <span *ngIf="cellInfo.value?.isValid">{{cellInfo.value | formatDateTime : 'dd LLL yyyy'}}</span>
        </div>

        <div *dxTemplate="let cellInfo of 'flagTemplate'">
            <i [ngClass]="cellInfo.value ? 'fas fa-check-square fa-2x' : 'far fa-square fa-2x'"></i>
        </div>

        <div *dxTemplate="let cellInfo of 'linkTemplate'">
            <span class="link-template"
                (click)="openLink(cellInfo.value, cellInfo.data)">{{cellInfo.value}}</span>
        </div>

        <div *dxTemplate="let cellInfo of 'truncateTemplate'">
            <div title="{{cellInfo.value}}" class="truncateHtml" [innerHTML]="cellInfo.value | safeHtml"></div>
        </div>

        <div *dxTemplate="let cellInfo of 'buttonTemplate'">
            <button class="eidos-button eidos-button-outlined eidos-button-success"
                (click)="selectRow(cellInfo.data)">
                {{ modalData.actionButtonText ?? 'Select' }}
            </button>
        </div>

        </dx-data-grid>

        <div *ngIf="loading" class="grid-modal--loading">
            <eidos-progress-spinner [diameter]="80"></eidos-progress-spinner>
        </div>
    </div>

    <div class="grid-modal--actions">
        <button class="eidos-button eidos-button-outlined eidos-button-big eidos-button-cancel"
            (click)="closeModal()">
            {{ modalData.closeButtonText ?? 'Close' }}
        </button>
        <button *ngIf="showExportButton" class="eidos-button eidos-button-outlined eidos-button-big eidos-button-success"
            [disabled]="loading || !hasRows" (click)="downloadGrid()">
            {{ modalData.exportButtonText ?? 'Download Report' }}
        </button>
    </div>
</div>
